const actions = {
    updateTab: ({ commit }, tab) => commit('updateTab', tab)
}

export default actions;
